import React from "react";
import { useEMarketplaceLayoutContext } from "./EMarketplaceLayoutContext";

export default function Banner(props: any) {
  const { banner } = useEMarketplaceLayoutContext();

  return <>{banner}</>;
}
